<template>
     <!--客户管理-->
    <div :class="phoneClass || 'user-list-container'">
        <content-header></content-header>
        <div class="dealer-table">
            <div class="search-bar">
                <div class="search-left">
<!--                    <div class="status-index">
                        <span class="top-title">{{$t("user.serviceProvider")}}</span>
                        <el-select v-model="searchForm.agentId" placeholder="请选择服务商" @change="getUserList">
                            <el-option
                                    v-for="item in agentList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>-->

                    <div class="status-index">
                        <span class="top-title" style="width: 100px">{{$t("user.serviceProvider")}}</span>
                        <el-select v-model="searchForm.agentId" clearable style="width:240px;" @change="initPage(),getUserList()">
                            <el-option
                                    v-for="item in agentAllList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="status-index">
                        <span class="top-title" style="width: 110px">{{$t("user.applicationStatus")}}</span>
                        <el-select v-model="userStatus" clearable style="width:160px;" :placeholder="$t('message.select')" @change="initPage(),getUserList()">
                            <el-option
                                    v-for="item in applyStatus"
                                    :key="item.index"
                                    :label="$t('selectData.user.status.status'+item.value)"
                                    :value="item.value">

                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="search-right">
                    <el-input
                            :placeholder="$t('user.selectUser')"
                            style="width:260px"
                            v-model="searchForm.username"
                            @change="initPage(),getUserList()">
                        <i slot="prefix" class="el-input__icon el-icon-search" ></i>
                    </el-input>
                </div>
            </div>
            <div class="table-outer">
                <el-table :data="userList" :header-cell-style="{background:'#fafbfc'}" class="normal-table" style="width: 100%">
                    <el-table-column min-width="180px" prop="company" :label="$t('user.customerName')"></el-table-column>
                    <el-table-column min-width="120px" prop="phone" :label="$t('user.phone')"></el-table-column>
                    <el-table-column min-width="180px" prop="email" :label="$t('user.email')" ></el-table-column>
                    <el-table-column min-width="400px" prop="address" :label="$t('user.address')" >
                        <template slot-scope="scope">
                            {{scope.row.country + scope.row.province + scope.row.city + scope.row.county +
                            scope.row.address}}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="100px" prop="contact_name" :label="$t('user.dealer')">
                        <template slot-scope="scope">
                            {{scope.row.agent_detail ? scope.row.agent_detail.name: '-'}}
                        </template>
                    </el-table-column>
                    <el-table-column min-width="150px" prop="create_time" :label="$t('user.correlationTime')">
                        <template slot-scope="scope">
                            {{scope.row.create_time | timeFormat(3)}}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column min-width="80px" :label="$t('user.disabled')" fixed="right">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.flagEnable"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeApi(scope.row, scope)">
                            </el-switch>
                        </template>
                    </el-table-column> -->
                    <el-table-column min-width="120px" :label="$t('user.apiSwitch')" fixed="right">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.flagApi"
                                active-color="#13ce66"
                                inactive-color="#ff4949"
                                @change="changeApi(scope.row, scope)">
                            </el-switch>
                            <a class="font-color-button" @click="showApiOpen(scope.row)" v-if="scope.row.flagApi === true">{{$t('user.view')}}</a>
                        </template>
                    </el-table-column>
                  <el-table-column min-width="120px" :label="$t('user.opcSwitch')" fixed="right">
                    <template slot-scope="scope">
                      <el-switch
                          v-model="scope.row.flagOpc"
                          active-color="#13ce66"
                          inactive-color="#ff4949"
                          @change="changeOpc(scope.row, scope)">
                      </el-switch>
                        <a class="font-color-button" @click="showOpcOpen(scope.row)" v-if="scope.row.flagOpc === true">{{$t('user.view')}}</a>
                    </template>
                  </el-table-column>
                    <el-table-column :label="$t('user.operation')" align="center" fixed="right" :width="phoneClass ? '' : '300'">
                        <div slot-scope="scope" class='my-table-button'>
                            <!--更改服务商-->
                            <el-button type="success"
                                @click="changeAgent(scope.row,scope)"
                                v-if="scope.row.apply_status === 0">
                                {{$t('user.replace')}}
                            </el-button>
                            <!--新申请-->
                            <el-button type="success"
                                    style="height:22px; width:90px; background-color:#0f68d6; border:none; color: white;"
                                    v-else
                                    @click="changeAgent(scope.row)">
                                {{$t('user.new_apply')}}
                            </el-button>
                            <el-button type="success"
                                    @click="clickEdit(scope.row)">
                                {{$t('user.eidt')}}
                            </el-button>
                            <el-button type="success"
                                    @click="clickDisabled(scope.row)">
                                {{ scope.row.is_enable === 0 ? $t('user.disabled'): $t('user.enabled')}}
                            </el-button>
                            <!-- <el-button type="danger" @click="clickDelete(scope.row)">{{$t('user.delelet')}}</el-button> -->
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination" style="text-align:right;padding:20px;">
                <el-pagination
                        @current-change="pageChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total"
                        background>
                </el-pagination>
            </div>
            <el-dialog width="450px" title="更改服务商" :visible.sync="showChangeAgent" class="detail-change">
                <div class="dialog">
                    <div class="dialog-top">
                        <!--原服务商：-->
                        <span style="">{{$t('user.origin')}} :</span>
                        <div class="content">{{this.agentForm.agent_detail ? this.agentForm.agent_detail.name: '-'}}
                        </div>
                    </div>
                    <!--<div class="dialog-top">-->
                        <!--<span>申请更改:</span>-->
                        <!--<div class="content">{{this.agentForm.apply_agent_detail ? this.agentForm.apply_agent_detail.name: '-'}}-->
                        <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="dialog" style="border-top: 1px solid #ccc;">
                    <div class="dialog-content">
                        <!--更换服务商为：-->
                        <span style="font-size: 14px;color: #363D42;">{{$t('user.replace_are')}}:</span>
                    </div>
                    <div class="dialog-select">
                        <el-select v-model="agentId" :placeholder="$t('message.select')">
                            <el-option
                                    v-for="item in agentAllList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="cancel" @click="cancelChange">取消</el-button>
                    <el-button type="primary" class="confirm" @click="confirmChangeAgent">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="修改密码" :visible.sync="showEdit" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ editRow.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('user.new_password')}}:</div>
                            <div class="form-value">
                                <el-input
                                    :placeholder="$t('retrieve.new_password')"
                                    style="width:260px"
                                    v-model="newPassword">
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="cancel" @click="showEdit = false">取消</el-button>
                    <el-button type="primary" class="confirm" @click="confirmChangePassword">确认</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="查看api" :visible.sync="showApi" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ appData.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.appId')}}</div>
                            <div class="form-value">
                                {{appData.appId}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.appSecret')}}</div>
                            <div class="form-value">
                                {{appData.appSecret}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.alarmUrl')}}</div>
                            <div class="form-value">
                                {{appData.alarmUrl}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.dataReportUrl')}}</div>
                            <div class="form-value">
                                {{appData.dataReportUrl}}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('setting.deviceAddUrl')}}</div>
                            <div class="form-value">
                                {{appData.deviceAddUrl}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="confirm" @click="showApi = false">关闭</el-button>
                </div>
            </el-dialog>
            <el-dialog width="450px" title="查看opc" :visible.sync="showOpc" class="detail-change">
                <div class="dialog">
                    <div class="dialog-form">
                        <div class="form-item">
                            <div class="form-label">{{$t('user.customerName')}}:</div>
                            <div class="form-value">
                                {{ opcData.company }}
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="form-label">{{$t('user.opcParam')}}:</div>
                            <div class="form-value">
                                {{ opcData.opc_param }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dialog-bottom">
                    <el-button class="confirm" @click="showOpc = false">关闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>


<script>
    import Core from "core/core";
    import contentHeader from '../../components/content-header'
    import region from "core/region"
    import {refresh} from "core/winSize"

    export default {
        data() {
            return {
	            phoneClass: '',
                agentAllList: [],
                currentPage: 1,
                pageSize: 10,
                total: 0,
                searchForm: {
                    agentId: '',
                    username: ''
                },
                applyStatus: [
	                {
		                value: '',
		                label: '全部'
	                }, {
		                value: '1',
		                label: '新申请'
	                }
                ],
	            userStatus: '',
                userList: [],
                showChangeAgent: false,
                showEdit: false,
                popoverVisible: false,
                editRow: {},
                newPassword: '',
                agentForm: {
                    selectAgentId: '',
                    userId: ''
                },
                agentId: '',
                agentValue: '',

                appData: {
                    id: '',
                    appId: '',
                    appSecret: '',
                    alarmUrl: '',
                    dataReportUrl: '',
                    deviceAddUrl: '',
                    company: '',
                },
                opcData: {
                    opc_param: '',
                    company: '',
                },

                showApi: false,
                showOpc: false,
            };
        },
        components: {
            contentHeader
        },
	    created() {
		    refresh(this,'phoneClass-user-list-container');
		    window.onresize = function(){
			    setTimeout(function(){
				    refresh(this,'phoneClass-user-list-container');
			    },10)
		    };
	    },
        mounted() {
            this.getAgentListAll();
            this.getUserList()
        },
        computed: {},
        methods: {
            getUserList() {
                // username搜的是 company
                Core.Api.User.listAdmin(this.currentPage, this.searchForm.agentId, this.searchForm.username, this.userStatus).then(res => {
                    this.userList = res.list;
                    this.userList.forEach(item=>{
                        item.flagApi = !!item.is_open_api_enable;
                        item.flagOpc = !!item.is_opc_enable;
                    })
                    this.total = res.count
                })
            },
            getAgentListAll() {
                Core.Api.Agent.listAll().then(res => {
                    // console.log(res, "###");
                    this.agentAllList = [
                    {
                        name: '-',
                        id: 0
                    },
                    ...res.agent_list]
                })
            },
            pageChange(val) {
                this.currentPage = val;
                this.getUserList();
            },
            changeAgent(val,x) {
                this.showChangeAgent = true
                this.agentForm = val
                console.log(val,"val" )
                this.agentId = val.agent_id
            },
            confirmChangeAgent() {
	            this.$confirm('本次操作将更换该用户的运营商, 是否继续?', '提示', {
		            cancelButtonText: '取消',
		            confirmButtonText: '确定',
		            type: 'warning'
	            })
	            .then(() => {
		            console.log(this.agentForm);
		            return Core.Api.User.switchUserAgent(this.agentId, this.agentForm.id)
	            })
	            .then(() => {
		            this.$message.success('修改成功');
		            this.getUserList()
		            this.cancelChange()
	            })

            },
            /**确认修改密码 */
            confirmChangePassword() {
                Core.Api.User.updatePassword(this.editRow.id, this.newPassword).then(res =>{
                    this.$message.success('修改成功');
                    this.showEdit = false;
                }).catch(err => {
                    this.$message.warning('修改失败');
                    this.showEdit = false;
                })
            },
            /**切换API状态 */
            changeApi(row) {
                // console.log(row.flagApi ? 0 : row.app.id)
                // return;
                let flag = row.is_open_api_enable ? 0 : 1;
                Core.Api.User.openApi(row.id, flag, row.id).then(res =>{
                    let tips = row.company;
                    tips += row.flagApi ? ' 已开启API' : ' 已关闭API';
                    this.$message.success(tips);
                    this.getUserList();
                })
                // Core.Api.User.generateLoginKey(row.id).then(res => {
                //     console.log(res, "###");
                // })
            },
            /**切换API状态 */
            changeOpc(row) {
                let flag = row.is_opc_enable ? 0 : 1;
                Core.Api.User.opc(row.id, flag).then(res =>{
                    let tips = row.company;
                    tips += row.flagOpc ? ' 已开启OPC' : ' 已关闭OPC';
                    this.$message.success(tips);
                    this.getUserList();
                })
                // Core.Api.User.generateLoginKey(row.id).then(res => {
                //     console.log(res, "###");
                // })
            },
            /**点击编辑 */
            clickEdit(row) {
                this.newPassword = "";
                this.editRow = row;
                this.showEdit = true;
            },
            clickDisabled(row) {
                Core.Api.User.enable(row.id).then(res =>{
                    let tips = row.company;
                    tips += row.is_enable ? ' 已启用' : ' 已禁用';
                    this.$message.success(tips);
                    this.getUserList();
                })
            },
            /**点击删除 */
            clickDelete(row) {
                const ths = this;
                console.log('clickDelete>>', row);

                ths.$confirm('确定删除该客户？?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    ths.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
            },

            initPage(){
                this.currentPage = 1
                console.log("现在是第"+this.currentPage+"页");
            },
            cancelChange() {
                this.showChangeAgent = false
            },
            showApiOpen(item) {
                Core.Api.App.detailByUserId(item.id).then(res =>{
                    this.appData = res.detail
                    this.appData.company = item.company;
                })

                this.showApi = true;
            },
            showOpcOpen(item) {
                this.opcData.company = item.company;
                Core.Api.User.opcDetail(item.id).then(res =>{
                    this.opcData.opc_param = res.opc_mq_routing_key
                })

                this.showOpc = true;
            }
        },


    };
</script>

<style scoped lang="scss">
    @import '../../assets/style/mixin.scss';

    .user-list-container {
        background-color: #E5EBEF;
        height: 100%;
        .dealer-table {
            margin: 30px 40px;
            background-color: #FFFFFF;
            .search-bar {
                @include flex-sb;
                padding: 20px;
                .status-index {
                    margin-right: 12px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .search-left {

            }
            .search-right {

            }
            .table-outer {
                padding: 0 20px;
            }
            .detail-change {
                .dialog {
                    margin: 20px;

                    .dialog-top {
                        margin: 10px;
                        .content {
                            margin-left: 10px;
                            display: inline;
                        }
                    }
                    .dialog-content {
                        margin: 10px;
                    }
                    .dialog-select {
                        margin: 5px 10px 10px 10px;
                        display: inline-block;
                    }
                }
                .dialog-form {
                    width: 100%;
                    .form-item {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        margin-bottom: 15px;
                    }
                    // justify-content: space-between;
                    .form-label {
                        width: 120px;
                    }
                    .form-value {
                        width: calc(100% - 100px);
                    }
                }
                .dialog-bottom {
                    display: flex;
                    flex-direction: row-reverse;
                    align-items: center;
                    .confirm {
                        margin: 10px 10px;
                    }
                    .cancel {
                        width: 62px;
                        height: 28px;
                        margin-right: 10px;
                    }
                }
            }
        }
        .font-color-button{
            color: #0A3D95;
            cursor:pointer;
            font-size: 8px;
            padding-left: 5px;
        }
    }
</style>

<style lang="scss">
    .user-list-container {
        .el-button {
            background: #f5f8fa;
            border: 1px #ecf0f4 solid;
            color: #8e9db0
        }
        .el-button:active ,.el-button:hover{
            border: 1px #bad4ff solid;
            color: #2b6cda

        }

        .table-outer {
            .cell {
                white-space:nowrap;
                overflow:hidden; //超出的文本隐藏
                text-overflow:ellipsis; //溢出用省略号显示
            }
            .cell:hover {
                /*background: #e2e2e2;*/
                white-space: normal;
                overflow: visible; //超出的文本隐藏
                position: relative;
                z-index: 10000;
                text-overflow:clip;
                /*background: #f6f7fb;*/
            }

        }
    }
    .phoneClass-user-list-container {
        .dealer-table {
            .search-bar{
                padding-left: 10px;
                .search-left {
                margin-bottom: 15px;
                    display: flex;
                    flex-wrap: wrap;
                    .status-index {
                        margin-top: 15px;
                        .top-title {
                            width: 110px !important;
                        }
                        .el-select {
                            width: 60% !important;
                        }
                    }

                    div:nth-child(2) {
                        .el-select{
                        }
                    }
                }
                .search-right {
                    margin-bottom: 15px;
                }
            }
        }
        .el-button {
            background: #f5f8fa;
            border: 1px #ecf0f4 solid;
            color: #8e9db0;
        }
        .is-center {
            .cell {
                .my-table-button {
                    .el-button {
                        span {

                            font-size: 10px !important;
                        }
                    }
                }
                /*width: 100px;*/
            }
        }
        /*页码适配移动端*/
        .pagination {
            padding: 20px 0 !important;
            text-align: center !important;
            .el-pagination {
                padding: 0;
                button {
                    width: 20px;
                    min-width: 0;
                    height: 30px;
                }
                .el-pager {
                    .number {
                        margin: 0 3px !important;
                        padding: 0 !important;
                        min-width: 0px;
                        width: 20px !important;
                        height: 30px !important;
                    }
                    .el-icon-more {

                        margin: 0 3px !important;
                        padding: 0 !important;
                        min-width: 0px;
                        width: 20px !important;
                        height: 30px !important;
                    }
                }
            }
        }
    }
</style>
